import React, { Component } from 'react'
import { Box } from 'reactjs-admin-lte'
import { Button, ButtonToolbar } from 'react-bootstrap'
import WorkdocStore from 'stores/WorkdocStore'
import FontAwesome from 'react-fontawesome'
import 'pretty-checkbox/dist/pretty-checkbox.min.css'

var NotificationSystem = require('react-notification-system');

class FixLevelConfig extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading:false,
      data:[],
      work_state:[],
      headerTitles:[]
    }  
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.loadData()
  }

  componentWillReceiveProps(newProps){

  }

  loadData() {
    this.setState({loading:true})
    WorkdocStore.loadFixlevelConfig((result)=>{
      let headerTitles = result.work_state.map((item,index)=>{
        return item
      })
      this.setState({loading:false,data:result.data,work_state:result.work_state,headerTitles:headerTitles})
    })
  }

  onTaskChange(index,key) {
    let {data} = this.state
    if (data[index].config_detail[key].commission) {
      data[index].config_detail[key].commission = false
    } else {
      data[index].config_detail[key].commission = true
    }
    this.setState({data:data})
  }

  onSaveClick() {
    let {data,work_state} = this.state
    WorkdocStore.saveFixlevelConfig(data,(result)=>{
      if (result.status=='OK') {
        this._notificationSystem.addNotification({
          title: 'แจ้งเตือน',
          message: 'ทำการบันทึกเรียบร้อย',
          level: 'info',
          position: 'tc'
        })
      }
    })
  }

  renderRowData() {
    let {isPopover} = this.props
    let {data,headerTitles} = this.state
    if (data.length==0) {
      if (isPopover)
        return(<tr><td colSpan={4}>ไม่พบข้อมูล</td></tr>)
      else
        return(<tr><td colSpan={(4+headerTitles.length)*1}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=>{
          return(
            <tr key={index}>
              <td style={{width:'100px',minWidth:(isPopover?'':'100px')}} className='text-center'>{item.fixlevel_code}</td>
              <td style={{width:'100px',minWidth:(isPopover?'':'100px')}} className='text-center'>{item.fixlevel_code1}</td>
              <td style={{width:'100px',minWidth:(isPopover?'':'100px')}} className='text-center'>{item.fixlevel_code2}</td>
              <td className='text-left'>{item.detail}</td>
              {
                !isPopover?
                headerTitles.map((ritem,rindex)=>{
                  let key = item.config_detail.findIndex(x => x.value==ritem.value)
                  return(
                    <td key={rindex} className='text-center'>
                      <div className="pretty p-svg p-jelly p-round p-bigger p-without-label">
                        <input 
                          type="checkbox"
                          onChange={this.onTaskChange.bind(this,index,key)}
                          checked={item.config_detail[key].commission} 
                        />
                        <div className="state p-info">
                          <svg className="svg svg-icon" viewBox="0 0 20 20">
                            <path
                              d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                              style={{stroke:'white',fill:'white'}}>
                            </path>
                          </svg>
                          <label></label>
                        </div>
                      </div>  
                    </td>
                  )
                })
                :''
              }
            </tr>  
          )
        })
      )
    }
  }

  renderTable() {
    let {isPopover} = this.props
    let {headerTitles} = this.state
    return(
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid table-tool' style={{minWidth:(isPopover?'':'1024px')}}>
          <thead>
            <tr>
              <th className='text-center' colSpan={3}>รหัส</th>
              <th className='text-center' style={{width:'500px',minWidth:(isPopover?'':'500px')}}>นิยาม</th>
              {
                !isPopover?
                headerTitles.map((item,index)=>{
                  return(<th key={index} className='text-center' style={{width:'80px',minWidth:'80px'}}>{item.label}</th>)
                })
                :''
              }
            </tr>  
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
        </table>
      </div>  
    )
  }

  render() {
    let {isPopover} = this.props
    let {loading} = this.state
    return (
      <div>
        {isPopover?this.renderTable():
        <div>
          <Box loading={loading}>
            <Box.Header border={true}>
              <Box.Title>ระดับงานซ่อม</Box.Title>
              <Box.Tools>
                  
              </Box.Tools>
            </Box.Header>
            <Box.Body>
              {this.renderTable()}
            </Box.Body>     
            <Box.Footer>
              <ButtonToolbar className='pull-right'>  
                <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;บันทึก</Button>    
              </ButtonToolbar>  
            </Box.Footer>         
          </Box>
          <NotificationSystem ref="notificationSystem" />
        </div>  
        }
      </div>    
    )
  }
}

FixLevelConfig.defaultProps = {
  isPopover: false
}

export default FixLevelConfig;


// WEBPACK FOOTER //
// ./src/view/workdoc/fixlevel/FixLevelConfig.js